<template>
  <chat-message :prev-chat="prevChat" :chat="chat" @delete="$emit('delete', chat)">
    <template v-slot:message>
      <p
        class="markdown cursor-pointer"
        @click="openUserPanel('SignIn')"
        v-html="formatChatMessage"
      ></p>
    </template>
  </chat-message>
</template>

<script>
import { formatChatMessage } from 'Utilities'
import ChatMessage from 'Chats/ChatMessage'
import chatWidgetMixin from 'Chats/mixins/chatWidgetMixin'

export default {
  components: { ChatMessage },
  mixins: [chatWidgetMixin],

  computed: {
    formatChatMessage() {
      return formatChatMessage(this.chat.message_rich.message)
    }
  }
}
</script>
